<template>
    <section class="progress-container">
        <div
            role="progressbar"
            aria-valuemin="0"
            aria-valuemax="100"
            class="progress-track"
            :aria-valuenow="progress"
        >
            <div class="progress-fill"></div>
        </div>
    </section>
</template>

<script setup lang="ts">
defineProps({
    progress: {
        type: Number,
        default: 100,
    },
});
</script>

<style scoped>
@keyframes moveGradient {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.progress-container {
  width: 100%;
  margin: 0 auto;
}

.progress-track {
  width: 100%;
  height: 12px;
  background-color: #e6efff;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}

.progress-fill {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  border-radius: 6px;
  width: 100%;
  background: linear-gradient(90deg, #0066ff 25%, #80b4ff 50%, #0066ff 75%);
  background-size: 200% 100%;
  animation: moveGradient 2s linear infinite;
}
</style>
